import gql from 'graphql-tag';

import conversationsPageFragment from '../fragments/conversationsPageFragment';

export const queryConversationsPage = gql`
  query conversationsPage(
    $conversationOrigin: ConversationOrigin
    $count: Int!
    $offset: Int!
  ) {
    conversationsPage(
      conversationOrigin: $conversationOrigin
      count: $count
      offset: $offset
    ) {
      ...conversationsPageFragment
    }
  }
  ${conversationsPageFragment}
`;

export default queryConversationsPage;
